```vue
<template>
  <div class="relative z-20" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <!-- ฉากหลัง -->
    <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>
    <!-- โมดัล -->
    <div class="fixed inset-0 z-20 w-screen overflow-y-auto">
      <div class="flex min-h-full items-center justify-center p-4">
        <div
          class="relative w-full transform rounded-lg bg-gray-800 text-white shadow-xl transition-all sm:max-w-2xl max-h-[90vh] overflow-y-auto"
        >
          <div class="p-4 sm:p-6">
            <h3 class="text-xl font-semibold text-indigo-300 mb-4">เพิ่มอาชญากรใหม่</h3>
            <form @submit.prevent="handleSubmit">
              <div class="grid grid-cols-1 gap-3 sm:gap-4">
                <!-- ชื่อ, มีห้อง, จำนวนห้อง, เลเวล -->
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">ชื่อ</label>
                    <input
                      v-model="form.name"
                      type="text"
                      required
                      placeholder="ชื่ออาชญากร"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                    />
                    <p v-if="errorMessage" class="text-sm text-red-500 mt-1">{{ errorMessage }}</p>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">มีห้อง</label>
                    <select
                      v-model="form.hasRoom"
                      required
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                      @change="resetRoomIfNoRoom"
                    >
                      <option :value="true">มี</option>
                      <option :value="false">ไม่มี</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">จำนวนห้อง</label>
                    <select
                      v-model.number="form.room"
                      :disabled="!form.hasRoom"
                      :required="form.hasRoom"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200 disabled:opacity-50"
                    >
                      <option value="" disabled>เลือกจำนวนห้อง</option>
                      <option v-for="n in 9" :key="n + 1" :value="n + 1">{{ n + 1 }}</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">เลเวล</label>
                    <input
                      v-model.number="form.level"
                      type="number"
                      required
                      min="1"
                      placeholder="เลเวล"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                      @change="logLevelChange"
                    />
                  </div>
                </div>
                <!-- URL รูปภาพ -->
                <div>
                  <label class="block text-sm font-medium text-gray-300 mb-1">URL รูปภาพ</label>
                  <input
                    v-model="form.imageUrl"
                    type="url"
                    placeholder="URL รูปภาพ"
                    class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                  />
                </div>
                <!-- สถานะ -->
                <div class="grid grid-cols-2 sm:grid-cols-6 gap-3">
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">Stamina</label>
                    <input
                      v-model.number="form.stats.stamina"
                      type="number"
                      required
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                      @change="logStatChange('stamina', $event)"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">Strength</label>
                    <input
                      v-model.number="form.stats.str"
                      type="number"
                      required
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                      @change="logStatChange('str', $event)"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">Agility</label>
                    <input
                      v-model.number="form.stats.agi"
                      type="number"
                      required
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                      @change="logStatChange('agi', $event)"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">Intelligence</label>
                    <input
                      v-model.number="form.stats.int"
                      type="number"
                      required
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                      @change="logStatChange('int', $event)"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">Defense</label>
                    <input
                      v-model.number="form.stats.defense"
                      type="number"
                      required
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                      @change="logStatChange('defense', $event)"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">Luck</label>
                    <input
                      v-model.number="form.stats.luck"
                      type="number"
                      required
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                      @change="logStatChange('luck', $event)"
                    />
                  </div>
                </div>
                <!-- ข้อความสถานะ -->
                <p
                  v-if="statDifference < 0"
                  class="text-sm text-yellow-500 mt-2"
                >
                  คำแนะนำ: ขาด {{ Math.abs(statDifference) }} หน่วย (ค่าสถานะรวมควรเป็น {{ expectedStatTotal }})
                </p>
                <p
                  v-else-if="statDifference > 0"
                  class="text-sm text-red-500 mt-2"
                >
                  คำแนะนำ: เกิน {{ statDifference }} หน่วย (ค่าสถานะรวมควรเป็น {{ expectedStatTotal }})
                </p>
                <p v-else class="text-sm text-green-500 mt-2">
                  คำแนะนำ: ค่าสถานะครบถ้วน (ค่าสถานะรวม {{ expectedStatTotal }})
                </p>
                <!-- รางวัล -->
                <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">ชื่อเสียง</label>
                    <input
                      v-model.number="form.renownReward"
                      type="number"
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">เหรียญ</label>
                    <input
                      v-model.number="form.silverReward"
                      type="number"
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">ทอง</label>
                    <input
                      v-model.number="form.goldReward"
                      type="number"
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-1">เพชร</label>
                    <input
                      v-model.number="form.diamondReward"
                      type="number"
                      min="0"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                    />
                  </div>
                </div>
              </div>
              <!-- Sticky Footer -->
              <div
                class="sticky bottom-0 bg-gray-800 pt-4 mt-4 border-t border-gray-700 flex justify-end gap-3"
              >
                <button
                  type="button"
                  @click="$emit('close')"
                  class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition duration-200"
                >
                  ยกเลิก
                </button>
                <button
                  type="submit"
                  :disabled="!!errorMessage"
                  class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  เพิ่ม
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { projectFirestore } from '@/firebase/config';

export default {
  setup(_, { emit }) {
    const form = ref({
      name: '',
      hasRoom: false,
      room: '',
      level: 1,
      imageUrl: '',
      stats: {
        stamina: 0,
        str: 0,
        agi: 0,
        int: 0,
        defense: 0,
        luck: 0,
      },
      renownReward: 0,
      silverReward: 0,
      goldReward: 0,
      diamondReward: 0,
      rarityColors: {
        bgColor: 'bg-gray-700',
        textColor: 'text-white',
        borderColor: 'border-gray-600',
      },
      createdAt: new Date(),
    });

    const errorMessage = ref('');

    // Computed properties
    const expectedStatTotal = computed(() => {
      return form.value.level * 7;
    });

    const actualStatTotal = computed(() => {
      const stats = form.value.stats;
      return (stats.stamina || 0) + (stats.str || 0) + (stats.agi || 0) + (stats.int || 0) + (stats.defense || 0) + (stats.luck || 0);
    });

    const statDifference = computed(() => actualStatTotal.value - expectedStatTotal.value);

    // Logging functions
    const logLevelChange = (event) => {
      console.log(`Level changed to: ${event.target.value}, Form state:`, form.value);
    };

    const logStatChange = (stat, event) => {
      console.log(`${stat} changed to: ${event.target.value}, Form state:`, form.value);
    };

    // Reset room if hasRoom is false
    const resetRoomIfNoRoom = () => {
      if (!form.value.hasRoom) {
        form.value.room = '';
      }
    };

    const handleSubmit = async () => {
      try {
        // Check if a document with this name already exists
        const docRef = await projectFirestore.collection('gameCriminals').doc(form.value.name).get();
        if (docRef.exists) {
          errorMessage.value = 'ชื่อนี้มีอยู่แล้ว กรุณาใช้ชื่ออื่น';
          return;
        }

        // Validate stats
        if (
          form.value.stats.stamina < 0 ||
          form.value.stats.str < 0 ||
          form.value.stats.int < 0 ||
          form.value.stats.agi < 0 ||
          form.value.stats.defense < 0 ||
          form.value.stats.luck < 0
        ) {
          errorMessage.value = 'ค่าสถานะต้องไม่เป็นค่าติดลบ';
          return;
        }

        if (form.value.hasRoom && !form.value.room) {
          errorMessage.value = 'กรุณาเลือกจำนวนห้อง';
          return;
        }

        await projectFirestore.collection('gameCriminals').doc(form.value.name).set({
          name: form.value.name,
          hasRoom: form.value.hasRoom,
          room: form.value.hasRoom ? form.value.room : 0,
          level: form.value.level,
          imageUrl: form.value.imageUrl || '',
          stats: form.value.stats,
          renownReward: form.value.renownReward || 0,
          silverReward: form.value.silverReward || 0,
          goldReward: form.value.goldReward || 0,
          diamondReward: form.value.diamondReward || 0,
          rarityColors: form.value.rarityColors || {
            bgColor: 'bg-gray-700',
            textColor: 'text-white',
            borderColor: 'border-gray-600',
          },
          createdAt: form.value.createdAt || new Date(),
        });
        emit('close');
      } catch (error) {
        console.error('Error adding criminal:', error);
        errorMessage.value = 'เกิดข้อผิดพลาดในการเพิ่มอาชญากร';
      }
    };

    return { form, errorMessage, expectedStatTotal, actualStatTotal, statDifference, handleSubmit, logLevelChange, logStatChange, resetRoomIfNoRoom };
  },
};
</script>
```